import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from './LanguageSwitcher'

const Header: React.FC = () => {
  const { t } = useTranslation()

  return (
    <header className="flex-shrink-0 bg-white border-b border-border z-50">
      <div className="px-4 lg:px-6">
        <div className="flex items-center justify-between h-14">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <span className="text-white font-bold text-sm">字</span>
            </div>
            <div>
              <h1 className="text-lg font-bold text-text">{t('app.title')}</h1>
              <p className="text-xs text-text-light hidden sm:block">{t('app.subtitle')}</p>
            </div>
          </Link>

          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <nav className="hidden md:flex items-center gap-4">
              <Link to="/" className="text-sm text-text-secondary hover:text-primary transition-colors">
                {t('nav.home')}
              </Link>
              <Link to="/help" className="text-sm text-text-secondary hover:text-primary transition-colors">
                {t('nav.help')}
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
